var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18px",
    height: "16px",
    viewBox: "0 0 40 52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Settings&amp;Information/Account/48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ford&You-MVP-Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FDS_Updated_Desktop-Landing-Page-",
    transform: "translate(-330.000000, -1386.000000)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(207.000000, 1386.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings&Information/Account/48",
    transform: "translate(123.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0014111,27.5246597 C33.7345026,27.5246597 40,33.6828158 40,41.2794602 L40,51.1111111 L0,51.1111111 L0,41.2794602 C0,33.6828158 6.26952928,27.5246597 13.9985889,27.5246597 L26.0014111,27.5246597 Z M26.0014111,31.4517721 L14.0026207,31.4517721 C8.48704768,31.4517721 3.99959681,35.8623434 3.99959681,41.283423 L3.99959681,47.1800359 L36.0004032,47.1800359 L36.0004032,41.283423 C36.0004032,35.8623434 31.5129523,31.4517721 26.0014111,31.4517721 Z M19.9987904,0 C26.6311864,0 32.0016127,5.28238235 32.0016127,11.7971885 C32.0016127,18.3119946 26.6311864,23.5904142 19.9987904,23.5904142 C13.3704264,23.5904142 7.99596815,18.3119946 7.99596815,11.7971885 C7.99596815,5.28238235 13.3704264,0 19.9987904,0 Z M19.9987904,3.93107524 C15.5879448,3.93107524 11.9995968,7.45794718 11.9995968,11.7971885 C11.9995968,16.132467 15.5879448,19.659339 19.9987904,19.659339 C24.413668,19.659339 28.0020159,16.132467 28.0020159,11.7971885 C28.0020159,7.45794718 24.413668,3.93107524 19.9987904,3.93107524 Z",
    id: "PersonalProfiles"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/userProfile.0aae9912299ffeb4b7b72d79d4176c6b.svg";
export { ForwardRef as ReactComponent };